import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.1 8l-.8.2-2.6 1.6a4 4 0 00-1.7 3v6.4a4 4 0 001.7 3l2.6 1.6.8.2c.5 0 .9-.4.9-1.2V9.2c0-.8-.4-1.2-.9-1.2zM28 21.2l-1.3-.7a2.1 2.1 0 01-.7-1.3v-6.4a2.1 2.1 0 01.7-1.3l1.3-.7zM20.8 7H3.2A1.2 1.2 0 002 8.2v15.6A1.2 1.2 0 003.2 25h17.6a1.2 1.2 0 001.2-1.2V8.2A1.2 1.2 0 0020.8 7zM20 23H4V9h16z"/><path d="M12 11a5 5 0 105 5 5 5 0 00-5-5zm0 8a3 3 0 113-3 2.9 2.9 0 01-3 3z"/>';
export var VideoOutlineSVG = function VideoOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
VideoOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(VideoOutlineSVG);